import React from 'react';

const styles = require('./ComparisonTable.module.scss');

export interface Props {
  candidateContent: React.ReactNode;
  candidateTitle: string;
  jobContent: React.ReactNode;
  jobTitle: string;
}

// Side-by-side "what the job asks vs what the candidate has" table that
// heads each eligibility group, like the prototype's comparison panels.
export default function ComparisonTable({
  candidateContent,
  candidateTitle,
  jobContent,
  jobTitle,
}: Props) {
  return (
    <div className={styles['ui-comparison']}>
      <div className={styles['ui-comparison__column']}>
        <h4 className={styles['ui-comparison__title']}>{jobTitle}</h4>
        <div className={styles['ui-comparison__content']}>{jobContent}</div>
      </div>
      <div className={styles['ui-comparison__column']}>
        <h4 className={styles['ui-comparison__title']}>{candidateTitle}</h4>
        <div className={styles['ui-comparison__content']}>{candidateContent}</div>
      </div>
    </div>
  );
}
